import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { ContentType } from 'models/common';
import { getSelectedOrganization } from 'selectors/organizations';
import { QuickSendProgressData } from 'components/pages/quickSend/QuickSendProgressPage';
import { getLocale } from 'utils/i18n';
import { setQuickSendData } from 'utils/quickSendStorage';

interface QuickSendTopic {
  id: string;
  name: string;
  course_id: string;
  bundle_id?: string;
  errors?: string[];
}

export const useQuickSend = () => {
  const organization = useSelector(getSelectedOrganization);

  return useCallback(
    (topic: QuickSendTopic) => {
      const progressData: QuickSendProgressData = {
        courseId: topic.course_id || '',
        organizationId: organization?.id ?? null,
        documents: [
          { id: topic.id, type: ContentType.Topic, parentId: topic.bundle_id },
        ],
        documentsForTracking: [{ id: topic.id, type: ContentType.Topic }],
        id: topic.id,
        name: topic.name || '',
        iconUrl: '',
        resourceType: 'topics',
      };

      const key = setQuickSendData(progressData);
      if (!key) return; // storage write failed — do not open a broken tab

      const url = `/${getLocale()}/quick-send/progress?key=${key}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    [organization],
  );
};
